const commonApiEndpoints = {
    getI18n: '/common/i18n',
};

export default commonApiEndpoints;
